import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// EditCompany page components
import FormField from "components/Form/FormField";
import MDDropzone from "components/MDDropzone";

function EditForm({ formData, onFileChange }) {
  const { formField, values, errors, touched } = formData;
  const { id, name, email, website, description, phoneNumber, shortNumber } = formField;
  const {
    id: idV,
    name: nameV,
    email: emailV,
    website: websiteV,
    description: descriptionV,
    phoneNumber: phoneNumberV,
    shortNumber: shortNumberV,
  } = values;

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">المعلومات الرئيسية</MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={name.type}
              label={name.label}
              name={name.name}
              value={nameV}
              placeholder={name.placeholder}
              error={errors.name && touched.name}
              success={nameV.length > 0 && !errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={email.type}
              label={email.label}
              name={email.name}
              value={emailV}
              placeholder={email.placeholder}
              error={errors.email && touched.email}
              success={emailV.length > 0 && !errors.email}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={website.type}
              label={website.label}
              name={website.name}
              value={websiteV}
              placeholder={website.placeholder}
              error={errors.website && touched.website}
              success={websiteV.length > 0 && !errors.website}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={description.type}
              label={description.label}
              name={description.name}
              value={descriptionV}
              placeholder={description.placeholder}
              error={errors.description && touched.description}
              success={descriptionV.length > 0 && !errors.description}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={phoneNumber.type}
              label={phoneNumber.label}
              name={phoneNumber.name}
              value={phoneNumberV}
              placeholder={phoneNumber.placeholder}
              error={errors.phoneNumber && touched.phoneNumber}
              success={phoneNumberV.length > 0 && !errors.phoneNumber}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={shortNumber.type}
              label={shortNumber.label}
              name={shortNumber.name}
              value={shortNumberV}
              placeholder={shortNumber.placeholder}
              error={errors.shortNumber && touched.shortNumber}
              success={shortNumberV.length > 0 && !errors.shortNumber}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

EditForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  onFileChange: PropTypes.func, // Prop type for file change handler
};

export default EditForm;
